import { styled } from '../../Styles/stitches.config'

export const StyledBadge = styled('span', {
    alignItems: 'center',
    bgc: '$primary300',
    borderRadius: '$2',
    display: 'flex',
    fontSize: '0.75rem',
    fontWeight: 600,
    h: 20,
    minW: 20,
    placeContent: 'center',
    position: 'absolute',
    px: '$1',
    right: 0,
    top: 0,
    transform: 'scale(1) translate(50%, -50%)',
    transformOrigin: '100% 0%',
    transition: '$default',

    variants: {
        showBadge: {
            false: {
                transform: 'scale(0) translate(50%, -50%)',
            },
        },
        variant: {
            dot: {
                minW: 8,
                h: 8,
                px: 0,
            },
        },
    },
})

export const BadgeWrapper = styled('span', {
    position: 'relative',
})
